import React from 'react';
import PropTypes from 'prop-types';
import { isExpired } from '@/utils/dateTimeUtils';

export default function ExpiredTag(props) {
  const { resource } = props;

  if (
    resource.data.completed ||
    resource.data.cancelled ||
    !isExpired(resource.data.endDate)
  ) {
    return null;
  }

  return (
    <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800">
      EXPIRED
    </span>
  );
}

ExpiredTag.propTypes = {
  resource: PropTypes.shape({
    data: PropTypes.shape({
      completed: PropTypes.bool,
      cancelled: PropTypes.bool,
      endDate: PropTypes.string
    })
  }).isRequired
};
